import React from "react";
import Translator from "Languages/Utility/Translator";

export const checkType = (type) => {
  switch (type) {
    case 1:
      return "lolayi";
    case 2:
      return "keshoyi";
    case "lolayi":
      return 1;
    case "keshoyi":
      return 2;
    default:
      return "lolayi";
  }
};

export const checkStruct = (struct) => {
  switch (struct) {
    case 1:
      return "upvc";
    case 2:
      return "alu";
    default:
      return "upvc";
  }
};

export const toggleFixerLastik = [
  {
    title: <Translator id={"fixer"} noSpan />,
    value: "fixer",
  },
  {
    title: <Translator id={"lastik"} noSpan />,
    value: "lastik",
  },
];

export const toggleNFixerLastik = [
  { value: "fixer", key: "fixer" },
  { value: "lastik", key: "lastik" },
];

export const toggleLolayiKeshoyi = [
  {
    title: <Translator id={"hinged"} noSpan />,
    value: "lolayi",
  },
  {
    title: <Translator id={"sliding"} noSpan />,
    value: "keshoyi",
  },
];

export const toggleNLolayiKeshoyi = [
  { value: "lolayi", key: "hinged" },
  { value: "keshoyi", key: "sliding" },
];

export const toggleAluminiumUpvc = [
  {
    title: <Translator id={"upvc"} noSpan />,
    value: "upvc",
  },
  {
    title: <Translator id={"alu"} noSpan />,
    value: "alu",
  },
];

export const toggleNAluminiumUpvc = [
  { value: "upvc", key: "upvc" },
  { value: "alu", key: "alu" },
];

export const toggleChangeType = [
  {
    title: <Translator id={"multiply"} noSpan />,
    value: "1",
  },
  {
    title: <Translator id={"increase"} noSpan />,
    value: "2",
  },
  {
    title: <Translator id={"decrease"} noSpan />,
    value: "3",
  },
];

export const toggleNChangeType = [
  { value: 1, key: "multiply", disabled: false },
  { value: 2, key: "increase", disabled: false },
  { value: 3, key: "decrease", disabled: false },
];

export const togglePercentRiyal = [
  {
    title: <Translator id={"percent"} noSpan />,
    value: true,
  },
  {
    title: <Translator id={"moneyUnit"} noSpan />,
    value: false,
  },
];
export const toggleNPercentRiyal = [
  { value: true, key: "percent" },
  { value: false, key: "moneyUnit" },
];
export const toggleChangeShishe = [
  {
    title: <Translator id={"Glass"} noSpan />,
    value: 2,
  },
  {
    title: <Translator id={"GroupGlass"} noSpan />,
    value: 1,
  },
  {
    title: <Translator id={"Spicer"} noSpan />,
    value: 3,
  },
];
export const toggleNChangeShishe = [
  { value: 2, key: "Glass" },
  { value: 1, key: "GroupGlass" },
  { value: 3, key: "Spicer" },
  { value: 4, key: "all" }
];

export const toggleYaraghMode = [
  {
    title: <Translator id={"dual_mode"} noSpan />,
    value: 2,
  },
  {
    title: <Translator id={"single_mode"} noSpan />,
    value: 1,
  },
  {
    title: <Translator id={"normal_mode"} noSpan />,
    value: 3,
  },
];

export const toggleAccessoryFoldSlide = [
  {
    title: <Translator id={"dual_mode"} noSpan />,
    value: 2,
  },
  {
    title: <Translator id={"single_mode"} noSpan />,
    value: 1,
  },
  {
    title: <Translator id={"normal_mode"} noSpan />,
    value: 0,
  },
];
export const toggleNAccessoryFoldSlide = [
  { value: 2, key: "dual_mode" },
  { value: 1, key: "single_mode" },
  { value: 0, key: "normal_mode" },
];

export const toggleWinDoor = [
  {
    title: <Translator id={"window"} noSpan />,
    value: 1,
  },
  {
    title: <Translator id={"door"} noSpan />,
    value: 2,
  },
];
export const toggleNWinDoor = [
  { value: 1, key: "window" },
  { value: 2, key: "door" },
];

export const toggleFomMastik = [
  {
    title: <Translator id={"foam"} noSpan />,
    value: 1,
  },
  {
    title: <Translator id={"mastic"} noSpan />,
    value: 2,
  },
];
export const toggleNFomMastik = [
  { value: 1, key: "foam" },
  { value: 2, key: "mastic" },
];

export const toggleAciveDiActive = [
  {
    title: <Translator id={"active"} noSpan />,
    value: true,
  },
  {
    title: <Translator id={"disable"} noSpan />,
    value: false,
  },
];
export const toggleNAciveDiActive = [
  { value: true, key: "active" },
  { value: false, key: "disable" },
];

export const toggleAdminUser = [
  {
    title: <Translator id={"admin"} noSpan />,
    value: 1,
  },
  {
    title: <Translator id={"user"} noSpan />,
    value: 2,
  },
];
export const togglenAdminUser = [
  { value: 1, key: "admin" },
  { value: 2, key: "user" },
];

export const convertGroups = [
  {
    value: 1,
    label: <Translator id={"olgo"} noSpan />,
  },
  {
    value: 2,
    label: <Translator id={"shishe"} noSpan />,
  },
  {
    value: 3,
    label: <Translator id={"tori"} noSpan />,
  },
  {
    value: 4,
    label: <Translator id={"yaragh"} noSpan />,
  },
  {
    value: 5,
    label: <Translator id={"profile"} noSpan />,
  },
];

export const toggleCheckCash = [
  { value: 1, key: "byCash" },
  { value: 2, key: "byCheck" },
];

export const togglePaymentType = [
  {
    title: <Translator id={"bank_portal"} noSpan />,
    value: "1",
    disabled: false,
  },
  {
    title: <Translator id={"wallet"} noSpan />,
    value: "2",
    disabled: false,
  },
];

export const toggleNPaymentType = [
  { value: "1", key: "bank_portal", disabled: false },
  { value: "2", key: "wallet", disabled: false },
];

export const toggleMedia = [
  { value: 1, key: "photo" },
  { value: 2, key: "video" },
];
